import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { RtiAuthenticationService } from '../authentication/rti-authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class RtiTokenInterceptor implements HttpInterceptor {
  //
  // intercept
  //
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //
    // Set the Authorization Header
    //
    // request = request.clone({
    //   setHeaders: {
    //     Authorization: `Bearer ${this.auth.getToken()}`
    //   }
    // });

    return next.handle(request);
  }

  constructor(protected auth: RtiAuthenticationService) {
  }
}
